// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__b3rXt","subContainer":"Profile_subContainer__VDw8E"};